import React from "react";
 
interface TicketsIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  backgroundColor?: string;
}
 
const TicketsIcon: React.FC<TicketsIconProps> = ({
  fill,
  backgroundColor,
  ...props
}) => {
  return (
<svg
      width={24}
      height={24}
      viewBox="0 0 30 30"
      {...props}
>
      {/* Background rectangle */}
<rect
        x={5.625}
        y={3.75}
        width={18.75}
        height={22.5}
        rx={2}
        fill={backgroundColor}
      />
      {/* Ticket path */}
<path
        fill={fill}
        d="M5.625 3.75v22.5h18.75V3.75H5.625Zm-.938-1.875h20.625a.937.937 0 0 1 .938.938v24.375a.938.938 0 0 1-.938.937H4.688a.938.938 0 0 1-.937-.938V2.813a.937.937 0 0 1 .938-.937ZM9.375 15h11.25v1.875H9.375V15Zm0-5.625H15v1.875H9.375V9.375Zm0 11.25h11.25V22.5H9.375v-1.875Z"
      />
</svg>
  );
};
 
export default TicketsIcon;